import { getLocalStorageLanguageData } from './countriesHelpers';

export const loadGoogleMapsScript = () => {
  // Destroy old script
  document.querySelectorAll('script[src^="https://maps.googleapis.com"]').forEach(script => {
    script.remove();
  });

  if (window.google) delete window.google.maps;

  // Generate new Google Maps API script
  const newAPIScript = document.createElement('script');
  newAPIScript.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&language=${
    getLocalStorageLanguageData()?.googleLanguage
  }&key=${import.meta.env.REACT_APP_GOOGLE_STATIC_MAP_API_KEY}&callback=Function.prototype`;

  // Callback for the Google Maps API src
  window.googleMapsAPILoaded = () => {
    const event = new CustomEvent('googleMapsAPILoaded');
    window.dispatchEvent(event);
  };

  // Wait for the callback to be executed
  const apiLoaded = new Promise(resolve => {
    window.addEventListener('googleMapsAPILoaded', () => {
      resolve();
    });
  });

  // Append the script
  document.querySelector('head').appendChild(newAPIScript);

  return apiLoaded;
};
